import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { GerenciarPerfisUsuariosApiService } from './services/gerenciar-perfis-usuarios-api.service';
import { GerenciarPerfisUsuariosResolverData } from './models/gerenciar-perfis-usuarios-resolver-data';

@Injectable()
export class GerenciarPerfisUsuariosResolver implements Resolve<GerenciarPerfisUsuariosResolverData> {

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
  ) { }

  resolve(): Observable<GerenciarPerfisUsuariosResolverData> {
    return zip(
      this.gerenciarPerfisUsuariosApiService.listarUsuarios(),
      this.gerenciarPerfisUsuariosApiService.listarPapeis(),
      this.gerenciarPerfisUsuariosApiService.listarPermissoes(),
    ).pipe(
      map(([usuarios, papeis, permissoes]) => ({ usuarios, papeis, permissoes }))
    );
  }
}
